import { UNIFIED_HELP_CENTER_BASE_PATH, HELP_CENTERS_MANAGEMENT_BASE_PATH } from '@helpcenter/constants';
import { isDefaultHCCallsJiraEnabled, isJsmCsMasterFlagEnabled } from '@helpcenter/feature-flags';
import { di } from 'react-magnetic-di';
import { getRelativeBasePath } from '@atlassian/help-center-common-util/history';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { getEnv } from '../env';

export const isAdvancedHelpCenter = () => {
    return getRelativeBasePath().startsWith('/helpcenter') && !isUnifiedHelpHelpCenter();
};

export const isFlexiHCEnabledInDefaultHC = () => {
    return isDefaultHelpCenter();
};

export const isDefaultHelpCenter = () => {
    return getRelativeBasePath().startsWith('/servicedesk/customer');
};

export const isKoshEnabledForDefaultHelpCenter = () => {
    if (isDefaultHCCallsJiraEnabled() && isDefaultHelpCenter()) {
        return false;
    }
    return true;
};

export const isUnifiedHelpHelpCenter = () => {
    return getRelativeBasePath() === UNIFIED_HELP_CENTER_BASE_PATH;
};

export const isHelpCentersManagement = () => {
    return getRelativeBasePath() === HELP_CENTERS_MANAGEMENT_BASE_PATH;
};

export const isCSMHelpCenter = (helpCenterType: string) => {
    return isJsmCsMasterFlagEnabled() && helpCenterType === 'CUSTOMER_SERVICE';
};

export const getIsHelpHub = () => {
    return getEnv().helpCenterType === 'HELP_HUB';
};

export const isJcsOnlyRestrictedRoute = (customerAccountAvailability: string | undefined) => {
    di(isDefaultHelpCenter);
    return isDefaultHelpCenter() && customerAccountAvailability === 'JCS_ONLY';
};

export const getSlugForAdvancedHCFromArticleView = (url: string) => {
    const pattern =
        isCSMHelpCenter(getEnv().helpCenterType) &&
        FeatureGates.checkGate('csm_navigation_handling_for_confluence_embed_view')
            ? /https:\/\/.*?\/helpcenter\/([^/]+)\//
            : /https:\/\/.*?\/helpcenter\/([^/]+)\/portal\//;
    const match = url.match(pattern);
    return match && match[1] ? match[1] : undefined;
};

export const getSlugForHelpCenter = () => {
    const pattern = /\/helpcenter\/([^/?]*)/;
    const match = getRelativeBasePath().match(pattern);
    return match && match[1] ? match[1] : undefined;
};
